import url_ from "asset-data:assets/galleries/ua-2021-11-17/L1000416-bw_20b97a5e17__800.jpg";
export const url = url_;